/* Dog's Love Store — in-body product-card hydrator: pulls live price, image + rating so cards never go stale */
(function(){
  function money(c){ return '$' + (c/100).toFixed(2); }
  var PV=''; try{ var pvm=(location.search||'').match(/[?&]preview_theme_id=(\d+)/); if(pvm){ PV='&preview_theme_id='+pvm[1]; } }catch(e){}
  function run(){
    var cards = document.querySelectorAll('.article__body div[style*="box-shadow:0 1px 3px rgba(0,0,0,.05)"]');
    if(!cards.length){ return; }
    for(var i=0;i<cards.length;i++){ (function(card){
      var links = card.querySelectorAll('a[href*="/products/"]');
      if(!links.length){ return; }
      var handle = null;
      for(var j=0;j<links.length;j++){ var mm = (links[j].getAttribute('href')||'').match(/\/products\/([a-z0-9\-]+)/i); if(mm){ handle = mm[1]; break; } }
      if(!handle){ return; }
      fetch('/products/'+handle+'?view=dlscard'+PV, {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.text() : null; })
        .then(function(t){ if(!t){ return; } var d; try{ d = JSON.parse(t); }catch(e){ return; } hydrate(card, d); })
        .catch(function(){});
    })(cards[i]); }
  }
  function hydrate(card, d){
    try{
      var titleA = card.querySelector('a[href*="/products/"][style*="color:#1a6fb5"]');
      var imgSpan = card.querySelector('a[href*="/products/"] span[style*="background-image"]') || card.querySelector('a[href*="/products/"] span');
      /* price */
      if(titleA && typeof d.price === 'number'){
        var priceEl = titleA.nextElementSibling;
        if(priceEl){
          var txt = (d.price_varies && d.price_min !== d.price_max) ? ('From ' + money(d.price_min)) : money(d.price);
          priceEl.textContent = txt;
        }
      }
      /* image */
      if(imgSpan && d.featured_image){
        var url = d.featured_image; if(url.indexOf('//')===0){ url = 'https:'+url; }
        imgSpan.style.backgroundImage = "url('" + url + "')";
      }
      /* rating */
      var rating = parseFloat(d.rating), count = parseInt(d.rating_count,10);
      if(titleA && !isNaN(rating) && rating > 0){
        var anchor = titleA.nextElementSibling || titleA;
        var el = card.querySelector('.dls-rating');
        var fresh = !el;
        if(fresh){ el = document.createElement('div'); el.className = 'dls-rating'; }
        el.setAttribute('style','clear:both;display:flex;align-items:center;gap:7px;margin:5px 0 10px;font-size:13.5px;color:#555;');
        var pct = Math.max(0, Math.min(100, (rating/5)*100));
        var cnt = (!isNaN(count) && count > 0) ? (count + (count===1 ? ' review' : ' reviews')) : '';
        el.innerHTML = '<span style="position:relative;display:inline-block;color:#d9d9d9;font-size:16px;letter-spacing:1px;line-height:1;">★★★★★<span style="position:absolute;left:0;top:0;overflow:hidden;white-space:nowrap;width:'+pct+'%;color:#f5a623;">★★★★★</span></span><b style="color:#1c1d1d;font-weight:700;">'+rating.toFixed(1)+'</b>'+(cnt ? '<span style="color:#8a8a8a;">'+cnt+'</span>' : '');
        if(fresh && anchor && anchor.parentNode){ anchor.parentNode.insertBefore(el, anchor.nextSibling); }
      }
    }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
